module.exports = "img/photo19.c212bc.jpeg";